
import { defineComponent, ref, computed } from 'vue'
import { useMemberModule } from '@/modules/members'
import { Member } from '@/modules/members/types'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'

export default defineComponent({
    name: 'search-for-member-dialog',
    emits: ['pickMember'],
    async setup (props, { emit }) {
        const { getMembers, members, membersCount, membersFilter } = useMemberModule()

        const searchForMemberColumns = ([
            { name: 'email', label: 'Email', field: 'email', sortable: true, align: 'left' },
            { name: 'firstName', label: 'First Name', field: 'firstName', sortable: true, align: 'left' },
            { name: 'lastName', label: 'Last Name', field: 'lastName', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const filter = ref<string>('')
        const currentPage = computed(() => [])
        const { loading, pagination, onRequest } = useAPIPagination(membersFilter, getMembers, membersCount, currentPage, true)

        function pickMember (member: Member) {
            emit('pickMember', member)
        }

        await onRequest({
            filter: filter.value || '',
            pagination: pagination.value
        })

        return {
            members,
            searchForMemberColumns,
            pickMember,
            pagination,
            loading,
            onRequest,
            filter
        }
    }
})
